import classNames from 'classnames';
import { useState } from 'react';
import { useDelayedUnmount } from 'hooks/utils/useDelayedUnmount';
import styles from './expander.module.scss';
import Icon from '../icon';

const Expander = ({
  title = '',
  children,
  className,
  titleClassName,
  expanded: isExpanded = false,
}) => {
  const [expanded, setExpanded] = useState(isExpanded);

  const [contentDisplayed, gridOpen] = useDelayedUnmount(expanded);

  const handleClick = () => {
    setExpanded(!expanded);
  };

  if (!title?.trim()) return null;

  return (
    <div className={classNames(styles.container, className)}>
      <button
        type="button"
        className={classNames(styles.title, titleClassName)}
        onClick={handleClick}
        aria-expanded={expanded}
      >
        <span>{title}</span>
        <span className={classNames(styles.button, { [styles.iconExpanded]: expanded })}>
          <Icon type="chevron" className={styles.icon} />
        </span>
      </button>
      <div
        className={classNames(styles.content, {
          [styles.contentHidden]: !gridOpen,
          [styles.contentDisplayNone]: !contentDisplayed,
        })}
      >
        <div className={styles.innerNoScroll}>{children}</div>
      </div>
    </div>
  );
};

export default Expander;
